import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { IConnectivityFeature } from './connectivity.feature.state';
import { ConnectivityState } from './connectivity.state';
import { nameof } from '@symphony-solo/shared/utils/src';

export const getConnectivityStatusState: MemoizedSelector<IConnectivityFeature, ConnectivityState> = createFeatureSelector<
  ConnectivityState
>(nameof<IConnectivityFeature>('connectivityFeature'));

export const getIsLoading = createSelector(getConnectivityStatusState, (state) => state.isLoading);
export const getConnectivityWifiStatus = createSelector(getConnectivityStatusState, (state) => state.isWifiConnected);
